<template>
  <div>
    <div>
      <MainNavBarWap :is-change="scrolledToTop" />
    </div>

    <div class="home-page-container " style="padding-bottom:100px;">
      <div
        ref="homePageCourses"
        class="container top-spacing"
        style="height:420px;"
      >
        <div class="flex">
          <div class="content_text">
            <div>
              <img :src="icons.AuthorIcon" alt="" />
            </div>
            <h2 class="h2-text">
              Start to improve your career
            </h2>
            <p class="p-text">
              Puzzles go been there to a by at planning if of that. Morning pile
              seven times of it empire convince cache there counter-productive
              disguised.
            </p>
            <div class="search-course">
              <SearchNavBar
                @change-select-courses="handleChangeSearchCourses"
              />
            </div>
          </div>
          <div class="flex colum flex-shrink">
            <!-- <img
              style="height: 140px; width:216px"
              class="pointer"
              :src="icons.VideoIcon"
              alt=""
            />
            <img
              style="height: 140px; width:216px; transform: translateX(-50px);"
              class="pointer"
              :src="icons.LearnIcon"
              alt=""
            />
            <img
              style="height: 140px; width:216px; transform: translateX(-100px);"
              class="pointer"
              :src="icons.TeacherIcon"
              alt=""
            /> -->
          </div>
        </div>
      </div>
      <div
        class="desktop"
        style="position: absolute; top:0px;bottom:0; right:0;z-index:-1;min-height:650px"
      >
        <div style="min-height: 650px;">
          <img
            style="height: 100%; max-height:650px;"
            :src="images.BackgroundHomePage"
          />
        </div>
      </div>
      <div style="position: absolute;z-index:-1 !important; bottom:0;">
        <img :src="icons.VectorIcon" alt="" />
      </div>
    </div>

    <div style="position: relative;">
      <div
        style="position: absolute; top:-80px;z-index:5 !important; left:50%;"
      >
        <img style="width:60px" :src="icons.ArrowIcon" alt="" />
      </div>
    </div>
    <div
      style="margin-top: 80px;  
    "
    >
      <div
        v-if="dataCourses.length !== 0"
        style="position: relative;"
        class="list-courses-container"
      >
        <div class="flex justify-center mb-10">
          <h2 class="fw-600 title-h2 text-center">
            Popular courses
          </h2>
        </div>
        <div class="mobile" style="margin-bottom: 65px;">
          <div
            style="display: flex; justify-content: center; align-items: center; position: absolute; z-index: 100; left: 50%;top:85px;transform: translate(-50%, -50%);"
          >
            <div>
              <img
                style="margin-right: 20px;"
                @click="showPrevCourses"
                :src="icons.ArrowPrevActiveIcon"
                alt=""
              />

              <img
                @click="showNextCourses"
                class="arrow-next"
                :src="icons.ArrowNextActiveIcon"
                alt=""
              />
            </div>
          </div>
        </div>
        <div
          :style="{ marginLeft: this.marginLeft + 'px' }"
          class="home-page-courses"
        >
          <div>
            <vue-slick-carousel
              ref="carouselSlick"
              style="max-height:490px"
              v-if="dataCourses.length && dataCourses.length !== 0"
              v-bind="slickOptions"
            >
              <div v-for="item in dataCourses" :key="item">
                <div class="flex">
                  <CardCourses :object-data="item" />
                  <div class="opac-0">hu</div>
                </div>
              </div>
            </vue-slick-carousel>
          </div>
        </div>
        <div class="flex justify-center mt-10">
          <button @click="$router.push('Courses')" class="add-courses">
            See all
          </button>
        </div>
      </div>
    </div>
    <div class="category-courses">
      <div class="px-15">
        <div class="flex justify-center">
          <h2 class="fw-600 title-h2 text-center">
            Categories
          </h2>
        </div>
        <!-- <span class="flex justify-center text-center"
          >Find when and be of where luxury. Avoid house. Muff whole his a
          explorations.</span> -->
      </div>
      <div>
        <div class="desktop">
          <div class="container">
            <el-row :gutter="20">
              <el-col
                v-for="(category, index) in listCategory"
                :key="index"
                :xs="24"
                :sm="12"
                :md="8"
                :lg="8"
                class="card-category"
              >
                <div class="flex">
                  <category :object-data="category" />
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div
          class="mobile home-page-courses "
          :style="{ marginLeft: this.marginLeft + 'px' }"
        >
          <div>
            <vue-slick-carousel
              v-if="listCategory.length && listCategory.length !== 0"
              v-bind="slickOptionsCate"
              ref="carousel"
            >
              <div
                v-for="(category, indexCate) in listCategory"
                :key="indexCate"
              >
                <div class="flex">
                  <category :object-data="category" />
                  <div class="opac-0">u</div>
                </div>
              </div>
            </vue-slick-carousel>
          </div>
          <div
            style="display: flex; justify-content: center; align-items: center; position: absolute; z-index: 100; left: 40%;bottom: -70px;"
          >
            <div>
              <img
                style="margin-right: 20px;"
                @click="showPrev"
                :src="icons.ArrowPrevActiveIcon"
                alt=""
              />

              <img
                @click="showNext"
                class="arrow-next"
                :src="icons.ArrowNextActiveIcon"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container regster-info">
      <registerInfo />
    </div>
  </div>
</template>

<script>
import MainNavBarWap from "@/layout/MainNavbar.vue";
import VideoIcon from "@/assets/img/svg_edu/Video.svg";
import LearnIcon from "@/assets/img/svg_edu/LearnIcon.svg";
import TeacherIcon from "@/assets/img/svg_edu/TeacherIcon.svg";
import BackgroundHomePage from "@/assets/img/img_edu/Hero section (6).png";
import SearchNavBar from "../components/search/SearchNavBar.vue";
import ArrowIcon from "@/assets/img/svg_edu/arrow-education-icon.svg";
import AuthorIcon from "@/assets/img/svg_edu/Author.svg";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import CardCourses from "@/views/components/card/CardCoursesS2.vue";
import CoursesResource from "@/views/api/courses";
import registerInfo from "./registerInfo.vue";
import Category from "@/views/components/card/cardCategory.vue";
import BannerHeader from "@/assets/img/homepage/bannerHeader.png";
import Arrow1Icon from "@/assets/img/svg_edu/arrow-3-education-x-template 1.svg";
import VectorIcon from "@/assets/img/svg_edu/Vector (1).svg";
import ArrowNextActiveIcon from "@/assets/img/svg/arrow-next-active.svg";
import ArrowPrevActiveIcon from "@/assets/img/svg/arrow-prev-active.svg";
export default {
  components: {
    MainNavBarWap,
    SearchNavBar,
    CardCourses,
    VueSlickCarousel,
    registerInfo,
    Category
  },
  bodyClass: "home-page",
  props: {},
  async created() {
    this.onGetListCategory();
    this.onGetList();
    setTimeout(() => {
      this.onGetList();
    }, 1500);
  },
  data() {
    return {
      marginLeft: 0,

      listCategory: [],
      dataCourses: [],
      scrolledToTop: true,
      images: {
        BannerHeader,
        BackgroundHomePage
      },
      query: {
        page: 1,
        limmit: 15
      },
      queryCate: {
        page: 1,
        limmit: 12
      },
      icons: {
        ArrowNextActiveIcon,
        ArrowPrevActiveIcon,
        TeacherIcon,
        VideoIcon,
        LearnIcon,
        ArrowIcon,
        AuthorIcon,
        Arrow1Icon,
        VectorIcon
      },
      slickOptionsCate: {
        dots: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        variableWidth: true
      },
      slickOptions: {
        dots: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              dots: false,
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: false,
              variableWidth: true
            }
          }
        ]
      }
    };
  },
  watch: {},
  mounted() {
    this.updateMarginLeft();
    // Lắng nghe sự kiện resize của cửa sổ
    window.addEventListener("resize", this.updateMarginLeft);
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("resize", this.updateMarginLeft);

    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    updateMarginLeft() {
      // Lấy phần tử sử dụng ref
      const box = this.$refs.homePageCourses;
      if (box) {
        const rect = box.getBoundingClientRect();
        this.marginLeft = Math.round(rect.left); // Lấy giá trị margin-left
        console.log("Margin left:", this.marginLeft);
      }
    },
    showNext() {
      this.$refs.carousel.next();
    },
    showPrev() {
      this.$refs.carousel.prev();
    },
    showNextCourses() {
      this.$refs.carouselSlick.next();
    },
    showPrevCourses() {
      this.$refs.carouselSlick.prev();
    },
    onGetListCategory() {
      CoursesResource.Category(this.queryCate).then(res => {
        const { error_code, data } = res;
        if (error_code !== 0) return;
        this.listCategory = data.data || [];
      });
    },
    onGetList() {
      CoursesResource.Lists(this.query)
        .then(res => {
          const { error_code, data } = res;
          if (error_code === 0) {
            this.dataCourses = data.data || [1, 2, 3];
          }
        })
        .finally(() => {});
    },
    handleScroll() {
      // Lấy vị trí hiện tại của cửa sổ
      const currentScrollPosition = window.scrollY;

      // Kiểm tra nếu vị trí hiện tại lớn hơn 200px từ đầu trang
      if (currentScrollPosition >= 70) {
        // Cập nhật trạng thái khi cuộn xuống
        this.scrolledToTop = false;
      } else {
        // Cập nhật trạng thái khi cuộn lên trên lại top
        this.scrolledToTop = true;
      }
    },
    handleChangeSearchCourses(val) {
      this.$router.push({
        name: "Courses",
        params: {
          keyword: val || null
        }
      });
    },
    handleRegister() {
      this.$store.dispatch("showRegisterDialog");
    }
  }
};
</script>
<style>
.card-category {
  margin-bottom: 20px;
}
.opac-0 {
  opacity: 0;
}
</style>
<style scoped>
.title-h2 {
  font-size: 30px;
}
.home-page-courses {
  padding-right: 15px;
  padding-left: 15px;
  width: 100%;
  position: relative;
  margin-right: 0;
}
.title-category {
  font-size: 30px;
}
.regster-info {
  margin-bottom: 20px;
  margin-top: 50px;
}
.add-courses {
  border-radius: 32px;
  background-color: #035ae0;
  color: #ffff;
  min-height: 48px;
  font-weight: 600;
  font-size: 16px;
  margin: 20px 0;
  padding: 0px 25px;
}
.search-course {
  margin-top: 35px;
}
.content_text {
  margin-top: 30px;
  max-width: 600px;
}
.p-text {
  max-width: 500px;
  color: #494949;
  margin-top: 30px;
  font-family: Archivo;
  font-size: 20px;
  font-weight: 400;
  line-height: 25px;
  text-align: left;
}
.h2-text {
  text-align: left;
  font-size: 60px;
  font-weight: 600;
  line-height: 65.2px;
  color: #242f41;
}
.home-page-container {
  height: 650px;
  position: relative;
  width: 100%;
  background-size: cover;
  background-position: right;
  background-repeat: no-repeat;
  overflow: hidden;
  z-index: 3;
}
.w-260 {
  width: 265px;
}
.px-20 {
  padding-left: 20px;
  padding-right: 20px;
}
.mb-10 {
  margin-bottom: 10px;
}
.md-title {
  margin-bottom: 20px;
  margin-left: 10px;
  margin-right: 10px;
}
.mt-20 {
  margin-top: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mr-20 {
  margin-right: 20px;
}
.ml-4 {
  margin-left: 4px;
}
.flex-grow {
  flex-grow: 1;
}

.top-spacing {
  padding-top: 100px;
}
@media screen and (min-width: 0px) and (max-width: 430px) {
}

@media screen and (min-width: 0px) and (max-width: 769px) {
  .title-h2 {
    font-size: 27px;
    line-height: 1;
  }
  .home-page-container {
    height: 500px;
    position: relative;
    width: 100%;
    background-size: cover;
    background-position: right;
    background-repeat: no-repeat;
    overflow: hidden;
    z-index: 3;
  }
  .regster-info {
    margin-bottom: 0;
    margin-top: 100px;
  }
  .h2-text {
    text-align: left;
    font-size: 26px;
    font-weight: 600;
    line-height: 35.2px;
    color: #242f41;
  }
  .title-category {
    text-align: center;
    font-size: 26px;
    line-height: 35.2px;
  }
  .p-text {
    max-width: 500px;
    color: #494949;
    margin-top: 22px;
    font-family: Archivo;
    font-size: 18px;
    font-weight: 400;
    line-height: 25px;
    text-align: left;
  }

  .top-spacing {
    padding-top: 80px;
  }
}
</style>

<style lang="scss">
$divider-color: #d9d9d9;

.divider-view {
  height: 15px;
  width: 100%;
  background-color: $divider-color;
}
.divider-view-top {
  height: 15px;
  width: 100%;
}
.background-image-el {
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}
.column {
  flex-direction: column;
}

.uppercase {
  text-transform: uppercase;
}
.full-width {
  width: 100%;
}

@media screen and (min-width: 770px) and (max-width: 1200px) {
}
@media screen and (min-width: 0px) and (max-width: 769px) {
}
</style>
